export const gravityForms = () => {
    let values = [];
    let hubspot = 0;
    jQuery('.pop-builder__wrap, .gform-pricing').on('input', 'input[type="email"]', function (e){
        values = [];
        jQuery('.gform_page:not(:last-child)').each(function (e){
            let title = jQuery(this).find('.has-tooltip .gsection_title').text() ? jQuery(this).find('.has-tooltip .gsection_title').text() : jQuery(this).find('.gfield_label').text();
            let allValues = [];
            jQuery(this).find('input').each(function (i){
                if( jQuery(this).is(':checked')){
                    allValues.push(jQuery(this).val());
                }
            })
            title ? values.push(title+': ' + allValues.join(', ')) : '';
        })
        get_pop();
        jQuery('.note-hubspot input').val(values.join('; \n  \n')).attr('value', values.join('; \n  \n'));
        jQuery('.number-hubspot input').val(hubspot).attr('value', hubspot);
    })


    function get_pop(){
        let size = [];
        let audience = [];
        let functional_company = [];
        let outcome_program = [];
        let program_format = [];
        jQuery('.size_organization input').each(function (i,e){
            if( jQuery(this).is(':checked')){
                size.push(jQuery(this).val());
            }else{
                size.push(false);
            }
        })
        jQuery('.audience_target input').each(function (i,e){
            if( jQuery(this).is(':checked')){
                audience.push(jQuery(this).val());
            }else{
                audience.push(false);
            }
        })
        jQuery('.functional_company input').each(function (i,e){
            if( jQuery(this).is(':checked')){
                functional_company.push(jQuery(this).val());
            }else{
                functional_company.push(false);
            }
        })
        jQuery('.outcome_program input').each(function (i,e){
            if( jQuery(this).is(':checked')){
                outcome_program.push(jQuery(this).val());
            }else{
                outcome_program.push(false);
            }
        })
        jQuery('.program_format input').each(function (i,e){
            if( jQuery(this).is(':checked')){
                program_format.push(jQuery(this).val());
            }else{
                program_format.push(false);
            }
        })

        if( audience[0] != false && outcome_program[0] != false){
            hubspot = 1;
        }else if( audience[0] != false &&  outcome_program[0] == false){
            hubspot = 2;
        }else if( (audience[1] != false || audience[2] != false) && outcome_program[3] != false &&  (size[3] != false || size[4] != false) ){
            hubspot = 3;
        }else if( (audience[1] != false || audience[2] != false) && outcome_program[3] != false &&  (size[0] != false || size[1] != false || size[2] != false) ){
            hubspot = 4;
        }else if( (audience[3] != false || audience[4] != false || audience[5] != false) && outcome_program[3] != false &&  (size[0] != false || size[1] != false || size[2] != false || size[3] != false) ){
            hubspot = 5;
        }else if( (audience[3] != false || audience[4] != false || audience[5] != false) && outcome_program[3] != false &&  size[4] != false){
            hubspot = 6;
        }else if( audience[0] == false && outcome_program[1] != false &&  functional_company[4] != false){
            hubspot = 7;
        }else if( audience[0] == false && outcome_program[1] != false &&  (functional_company[1] != false || functional_company[2] != false)){
            hubspot = 8;
        }else if( (audience[3] != false || audience[4] != false || audience[5] != false) && outcome_program[1] != false &&   functional_company[0] != false){
            hubspot = 9;
        }else if( audience[0] == false && outcome_program[1] != false &&  (functional_company[3] != false || functional_company[5] != false || functional_company[6] != false) &&  (size[0] != false || size[1] != false || size[2] != false)){
            hubspot = 10;
        }else if( audience[0] == false && outcome_program[1] != false &&  (functional_company[3] != false || functional_company[5] != false || functional_company[6] != false) &&  (size[3] != false || size[4] != false)){
            hubspot = 11;
        }else if( audience[0] == false && outcome_program[0] != false && (size[3] != false || size[4] != false)){
            hubspot = 12;
        }else if( audience[0] == false && outcome_program[0] != false && (size[0] != false || size[1] != false || size[2] != false)){
            hubspot = 13;
        }else if( audience[0] == false && outcome_program[2] != false){
            hubspot = 14;
        }else if( (audience[3] != false || audience[4] != false || audience[5] != false) && outcome_program[4] != false){
            hubspot = 15;
        }else if( (audience[1] != false || audience[2] != false) && outcome_program[4] != false){
            hubspot = 16;
        }
    }


    jQuery(document).on('gform_post_render', function(e, form_id, current_page) {
        if( form_id == 2) {
            if (jQuery('.validation_gf_2').length == 0) {
                jQuery("<div class='validation_gf_2'>Must select an option<span class='validation_gf_2__exit'>x</span> </div>").appendTo('#gform_wrapper_2');
            }
            if (jQuery('div.gform_validation_errors').length > 0 && current_page !=6) {
                jQuery('.validation_gf_2').addClass('open');
            }
            if (current_page == 6) {
                jQuery('.gf_page_steps, .gf_progressbar_wrapper').css('display', 'none');
            }else{
                jQuery('.gf_progressbar_wrapper').css('display', 'block');
            }
        }
        if (jQuery('.tooltip_gf').length == 0) {
            jQuery('.page-title.has-tooltip').each(function (i, e) {
                jQuery("<div class='tooltip_gf'></div>").prependTo(jQuery(this));
            })
        }
    });

    jQuery(document).on('click', '.validation_gf_2__exit', function(e) {
        jQuery('.validation_gf_2').removeClass('open');
    })

}


